import script from "./ai.vue?vue&type=script&setup=true&lang=js"
export * from "./ai.vue?vue&type=script&setup=true&lang=js"

import "./ai.vue?vue&type=style&index=0&id=4a4c6716&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4c6716"]])

export default __exports__